/* eslint-disable @typescript-eslint/no-require-imports */
import type { ExecutorchEmbeddingService } from "$src/core/services/search-classification/types";
import CustomPlatform from "$src/core/utils/platform/platform";

const ExecutorchEmbedding: ExecutorchEmbeddingService = CustomPlatform.select<
  () => ExecutorchEmbeddingService
>({
  native: () => require("./executorch-embedding").default,
  tv: () => require("./executorch-embedding.web").default,
  default: () => require("./executorch-embedding.web").default,
})();

export default ExecutorchEmbedding;
